// extracted by mini-css-extract-plugin
module.exports = {"spinner":"q_jw8","rotator":"_2Vu45","path":"Jsb_S","dash":"_3w3ow","bg":"_3d3QI"};